import { defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
/** @public */ export const snippetResourceProps = {
    // Maybe we could add something like goes well with or something like that
    // for some ai recommendations?A
    storageKey: T.string
};
/** @internal */ export const snippetResourceMigrations = defineMigrations({});
export const SWSnippetResourceInfo = {
    migrations: snippetResourceMigrations,
    props: snippetResourceProps,
    meta: {}
};
